import React from 'react';
import { Provider } from 'react-redux';
import { Router, browserHistory, match } from 'react-router';

import getRoutes from './routes';
import { handleDataDependencies } from '../lib/ssr/fetch-data';

import { pageview } from 'kodyl-js/tracking';

export default ({ history = browserHistory, store, routes, reload }) => {
  routes = routes || getRoutes(store);

  let provider = null;

  const router = (
    <Router onUpdate={() => window.scrollTo(0, 0)} history={history}>
      {routes}
    </Router>
  );

  const locationChange = (location, callback, reload = false) => {
    match(
      { history, location, routes },
      (error, redirectLocation, renderProps = {}) => {
        if (error || redirectLocation) {
          if (__DEV__ && error) {
            console.error(error);
          }
          return;
        }
        Promise.resolve()
          .then(() =>
            handleDataDependencies({ location, store, renderProps, reload })
          )
          .catch(err => {
            if (__DEV__) {
              console.error(err);
            }
          })
          .then(() => callback())
          .then(() =>
            handleDataDependencies({
              location,
              store,
              renderProps,
              deferred: true,
              reload
            })
          )
          .then(() => {
            pageview({ location });
          })
          .catch(err => {
            if (__DEV__) {
              console.error(err);
            }
          });
      }
    );
  };

  if (__CLIENT__) {
    const loc = window.location;
    const loca = history.createLocation(
      `${loc.pathname}${loc.search}${loc.hash}`
    );
    locationChange(loca, () => {}, reload);
  }

  history.listenBefore(locationChange);

  // if (__DEV__ && __DEVTOOLS__) {
  //   const DevTools = require('./redux/dev-tools').default;
  //   provider = (
  //     <Provider store={store}>
  //       <div className="fs">
  //         {router}
  //         <DevTools />
  //       </div>
  //     </Provider>
  //   );
  // } else {
  provider = <Provider store={store}>{router}</Provider>;
  // }

  return provider;
};
